<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="720px">
        <div class="row">
            <div class="col-12">
                <el-radio-group v-model="option" size="mini">
                    <el-radio-button label="Establecimientos de un tercero" v-if="showOptionEstablecimientosTerceros"></el-radio-button>
                    <el-radio-button label="Puertos" v-if="showOptionPuertos"></el-radio-button>
                    <el-radio-button label="Aeropuertos" v-if="showOptionAeropuertos"></el-radio-button>
                    <el-radio-button label="Otra dirección" v-if="showOptionOtraDireccion"></el-radio-button>
                </el-radio-group>
            </div>
            <div class="col-12 mt-2">
                <div class="row" v-if="option === 'Establecimientos de un tercero'">
                    <div class="col-12" style="display: flex; flex-direction: row;">
                        <x-button-icon icon="fal fa-refresh"
                                       style="margin-right: 8px;"
                                       tooltip-content="Actualizar los establecimientos por consulta api"
                                       @click="clickActualizarDomicilioFiscalEstablecimientos"></x-button-icon>
                        <x-input v-model="rucTercero"
                                 placeholder="Número de RUC"
                                 :maxlength="11"
                                 show-button-new
                                 icon-button="fal fa-search"
                                 style="flex-grow: 1"
                                 @click-button="getDomicilioFiscalEstablecimientosTercero"></x-input>
                    </div>
                    <template>
                        <div class="col-12 mt-2" v-if="all_establecimientos_tercero.length > 0">
                            <x-input v-model="search"
                                     placeholder="Filtrar por dirección o código"
                                     @input="filterAddresses"></x-input>
                        </div>
                        <div class="col-12">
                            <el-table :data="establecimientos_tercero"
                                      height="360"
                                      style="width: 100%">
                                <el-table-column prop="codigo"
                                                 label="Código"
                                                 width="80">
                                </el-table-column>
                                <el-table-column prop="direccion_completa"
                                                 label="Dirección">
                                </el-table-column>
                                <el-table-column width="100">
                                    <template slot-scope="scope">
                                        <x-button-icon icon="fal fa-check"
                                                       is-small
                                                       @click="clickRowTercero(scope.row)"></x-button-icon>
                                        <x-button-icon icon="fal fa-trash"
                                                       type="danger"
                                                       is-small
                                                       @click="clickRemoveTercero(scope.row.id)"></x-button-icon>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </template>
                    <div class="col-md-12 btn-actions">
                        <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
                    </div>
                </div>
                <div class="row" v-if="option === 'Puertos'">
                    <div class="col-12">
                        <table class="table table-sm x-table-view">
                            <tr>
                                <th style="width: 70px;">Código</th>
                                <th>Nombre</th>
                                <th>Dirección</th>
                                <th></th>
                            </tr>
                            <tr v-for="row in puertos">
                                <td>{{ row.codigo }}</td>
                                <td>{{ row.nombre }}</td>
                                <td>{{ row.direccion_completa }}</td>
                                <td>
                                    <x-button-icon icon="fal fa-check"
                                                   @click="clickRowPuerto(row)"></x-button-icon>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-12 btn-actions">
                        <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
                    </div>
                </div>
                <div class="row" v-if="option === 'Aeropuertos'">
                    <div class="col-12">
                        <table class="table table-sm x-table-view">
                            <tr>
                                <th style="width: 70px;">Código</th>
                                <th>Nombre</th>
                                <th>Dirección</th>
                                <th>Tipo</th>
                                <th></th>
                            </tr>
                            <tr v-for="row in aeropuertos">
                                <td>{{ row.codigo }}</td>
                                <td>{{ row.nombre }}</td>
                                <td>{{ row.direccion_completa }}</td>
                                <td>{{ row.tipo }}</td>
                                <td>
                                    <x-button-icon icon="fal fa-check"
                                                   @click="clickRowAeropuerto(row)"></x-button-icon>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-12 btn-actions">
                        <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
                    </div>
                </div>
                <div class="row" v-if="option === 'Otra dirección'">
                    <div class="col-4">
                        <x-input-mask v-model="form.code"
                                      label="Código de establecimiento"
                                      mask="####"></x-input-mask>
                    </div>
                    <div class="col-12">
                        <x-input label="Dirección"
                                 v-model="form.address"></x-input>
                    </div>
                    <div class="col-12">
                        <x-cascader label="Ubigeo"
                                    v-model="form.location"
                                    filterable
                                    :options="locations"></x-cascader>
                    </div>
                    <div class="col-12" v-if="numberRuc">
                        <x-switch-left v-model="saveAddress"
                                       label="Guardar dirección"></x-switch-left>
                    </div>
                    <div class="col-md-12 btn-actions">
                        <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
                        <x-button-submit @click="clickRowOtro" text="Aceptar"></x-button-submit>
                    </div>
                </div>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XInput from "../../../../components/Form/XInput.vue"
import XButtonIcon from "../../../../components/Form/XButtonIcon.vue"
import XModal from "../../../../components/XModal.vue"
import XButtonSubmit from "../../../../components/Form/XButtonSubmit.vue"
import XButtonCancel from "../../../../components/Form/XButtonCancel.vue"
import XCascader from "../../../../components/Form/XCascader.vue"
import XSwitchLeft from "../../../../components/Form/XSwitchLeft.vue"
import XInputNumber from "../../../../components/Form/XInputNumber.vue"
import XInputMask from "../../../../components/Form/XInputMask.vue";

export default {
    name: 'DispatchOriginAddressView',
    components: {XInputMask, XInputNumber, XSwitchLeft, XButtonCancel, XButtonSubmit, XModal, XButtonIcon, XInput, XCascader},
    props: ['showDialog', 'recordId', 'type', 'documentTypeId', 'transferReasonTypeId', 'numberRuc'],
    data() {
        return {
            loading: false,
            title: null,
            resource: 'origin_addresses',
            errors: {},
            form: {},
            option: '',
            search: '',
            rucRemitente: '',
            rucTercero: '',
            domicilio_fiscal: [],
            all_establecimientos_tercero: [],
            establecimientos_tercero: [],
            establecimientos_remitente: [],
            aeropuertos: [],
            puertos: [],
            showOptionEstablecimientosTerceros: false,
            showOptionPuertos: false,
            showOptionAeropuertos: false,
            showOptionOtraDireccion: false,
            locations: [],
            saveAddress: true
        }
    },
    created() {
        this.title = (this.type === 'origin' || this.type === 'sender') ? 'Punto de partida' : 'Punto de llegada'
        this.initTables()
        this.initForm()
        this.getAeropuertos()
        this.getPuertos()
    },
    methods: {
        async initTables() {
            this.loading = true
            await this.$http.get(`/store/get_table/locations`)
                .then(response => {
                    this.locations = response.data
                })
                .finally(() => {
                    this.loading = false
                })
        },
        initForm() {
            this.saveAddress = true
            this.errors = {}
            this.form = {
                code: '',
                address: null,
                location: [],
                ruc: null
            }
        },
        async handleOpen() {
            this.initForm()
            this.showOptionEstablecimientosTerceros = false
            this.showOptionPuertos = false
            this.showOptionAeropuertos = false
            this.showOptionOtraDireccion = true
            if (this.documentTypeId === '09') {
                if (this.transferReasonTypeId === '08' || this.transferReasonTypeId === '09') {
                    if (this.type === 'origin') {
                        this.showOptionEstablecimientosTerceros = true
                        this.showOptionPuertos = true
                        this.showOptionAeropuertos = true
                        this.showOptionOtraDireccion = false
                        this.option = 'Establecimientos de un tercero'
                    } else {
                        this.showOptionEstablecimientosTerceros = true
                        this.option = 'Establecimientos de un tercero'
                    }
                } else {
                    this.rucTercero = this.numberRuc
                    if (this.type === 'origin') {
                        this.showOptionEstablecimientosTerceros = true
                        this.option = 'Establecimientos de un tercero'
                        await this.getDomicilioFiscalEstablecimientosTercero()
                    } else {
                        this.showOptionEstablecimientosTerceros = true
                        this.option = 'Establecimientos de un tercero'
                        await this.getDomicilioFiscalEstablecimientosTercero()
                    }
                }
            } else {
                this.rucTercero = this.numberRuc
                this.showOptionEstablecimientosTerceros = true
                this.option = 'Establecimientos de un tercero'
                await this.getDomicilioFiscalEstablecimientosTercero()
            }
        },
        async getDomicilioFiscalEstablecimientosTercero() {
            console.log('getDomicilioFiscalEstablecimientosTercero')
            if (this.rucTercero !== null) {
                this.loading = true
                this.all_establecimientos_tercero = []
                await this.$http.get(`/dispatch_addresses/search_by_person_number/${this.rucTercero}`)
                    .then(response => {
                        this.all_establecimientos_tercero = response.data
                        this.filterAddresses()
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        },
        async clickActualizarDomicilioFiscalEstablecimientos() {
            console.log('clickActualizarDomicilioFiscalEstablecimientos')
            if (this.rucTercero !== null && this.rucTercero.length === 11) {
                this.loading = true
                this.all_establecimientos_tercero = []
                await this.$http.get(`/dispatch_addresses/update_establishments/${this.rucTercero}`)
                    .then(response => {
                        this.all_establecimientos_tercero = response.data
                        this.filterAddresses()
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        },
        async getPuertos() {
            console.log('getPuertos')
            this.puertos = []
            await this.$http.get(`/service/puertos`)
                .then(response => {
                    let data = response.data
                    if (data.success) {
                        this.puertos = data.data
                    }
                })
        },
        async getAeropuertos() {
            console.log('getAeropuertos')
            this.aeropuertos = []
            await this.$http.get(`/service/aeropuertos`)
                .then(response => {
                    let data = response.data
                    if (data.success) {
                        this.aeropuertos = data.data
                    }
                })
        },
        clickRowTercero(row) {
            let data = {
                type: 'establecimientos',
                code: row.codigo,
                name: '',
                ruc: this.rucTercero,
                address_full: row.direccion_completa,
                address: row.direccion,
                location_id: row.ubigeo_sunat
            }
            this.$emit('success', data)
        },
        clickRowPuerto(row) {
            let data = {
                type: 'puertos',
                code: row.codigo,
                name: row.nombre,
                ruc: '',
                address_full: row.direccion_completa,
                address: row.direccion,
                location_id: row.ubigeo_sunat
            }
            this.$emit('success', data)
        },
        clickRowAeropuerto(row) {
            let data = {
                type: 'aeropuertos',
                code: row.codigo,
                name: row.nombre,
                ruc: '',
                address_full: row.direccion_completa,
                address: row.direccion,
                location_id: row.ubigeo_sunat
            }
            this.$emit('success', data)
        },
        clickRowOtro() {
            if (this.form.code !== '' && this.form.code.length !== 4) {
                return this.$message.error('El código del establecimiento es incorrecto')
            }

            if (this.form.address === '' || this.form.address === null) {
                return this.$message.error('La dirección es requerida')
            }

            if (this.form.location === null || this.form.location.length !== 3) {
                return this.$message.error('El ubigeo es requerido')
            }

            let departament_id = this.form.location[0]
            let provincia_id = this.form.location[1]
            let distrito_id = this.form.location[2]
            let departamento_array = this.locations.find(row => row.value === departament_id)
            let departamento = departamento_array.label
            let provincia_array = departamento_array.children.find(row => row.value === provincia_id)
            let provincia = provincia_array.label
            let distrito_array = provincia_array.children.find(row => row.value === distrito_id)
            let distrito = distrito_array.label.split(' - ')[1]
            let address_full = this.form.address + ', ' + departamento + ' - ' + provincia + ' - ' + distrito
            let data = {
                type: 'establecimientos',
                code: '',
                name: '',
                ruc: '',
                address_full: address_full,
                address: this.form.address,
                location_id: distrito_id
            }
            if (this.saveAddress) {
                this.form.ruc = this.numberRuc
                this.$http.post(`/dispatch_addresses/store`, this.form)
            }
            this.$emit('success', data)
        },
        filterAddresses() {
            if (this.search !== '') {
                this.establecimientos_tercero = this.all_establecimientos_tercero.filter(row => {
                    return row.direccion_completa.toLowerCase().includes(this.search.toLowerCase()) ||
                        row.codigo.toLowerCase().includes(this.search.toLowerCase())
                })
            } else {
                this.establecimientos_tercero = this.all_establecimientos_tercero
            }
        },
        async clickRemoveTercero(id) {
            this.loading = true
            await this.$http.get(`/dispatch_addresses/delete_establishments/${id}`)
                .then(response => {
                    this.all_establecimientos_tercero = response.data
                    this.filterAddresses()
                })
                .finally(() => {
                    this.loading = false
                })
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        },
    }
}
</script>
